import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';
import { StatusBadge } from '../components/servers/ServerWidgets';
import { apiGetServers } from '../api/client';

const PROVIDER_LABEL = {
  godaddy: 'GoDaddy VPS',
  alibaba: 'Alibaba Cloud',
  tracking: 'Tracking',
  qr: 'QR',
  island: 'Island Tracking Cars',
};

function ServerCard({ server, onOpen }) {
  const pending = server.mode === 'pending' || server.status === 'pending';
  return (
    <button
      type="button"
      onClick={() => !pending && onOpen(server.id)}
      disabled={pending}
      style={{
        textAlign: 'left', width: '100%', cursor: pending ? 'default' : 'pointer',
        background: '#fff', borderRadius: 20, padding: '1.35rem 1.5rem',
        border: '1.5px solid #f1f5f9',
        opacity: pending ? 0.65 : 1,
        transition: 'all 0.2s',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, marginBottom: 10 }}>
        <div>
          <h3 style={{ fontSize: 18, fontWeight: 800, color: '#0f0f1a', margin: 0, letterSpacing: '-0.02em' }}>
            {server.name}
          </h3>
          <p style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>
            {PROVIDER_LABEL[server.provider] || server.provider}
            {server.mode === 'local' && ' · localhost monitor'}
            {server.mode === 'ssh' && ' · SSH private'}
          </p>
        </div>
        <StatusBadge status={server.status} />
      </div>
      {server.lastError && (
        <p style={{ fontSize: 12, color: '#b91c1c', marginTop: 8 }}>{server.lastError}</p>
      )}
      {pending && (
        <p style={{ fontSize: 12, color: '#64748b', marginTop: 8 }}>Monitor setup pending</p>
      )}
      {!pending && (
        <p style={{ fontSize: 12, color: '#0f766e', fontWeight: 600, marginTop: 10 }}>View dashboard →</p>
      )}
    </button>
  );
}

export default function ServersPage() {
  const navigate = useNavigate();
  const [servers, setServers] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const list = await apiGetServers();
        if (!cancelled) setServers(list);
      } catch (e) {
        if (!cancelled) setError(e.message || 'Failed to load servers');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <AppLayout>
      <div className="page-content">
        <div style={{ marginBottom: '2rem' }}>
          <h1 style={{ fontSize: 30, fontWeight: 800, color: '#0f0f1a', letterSpacing: '-0.03em', marginBottom: 4 }}>
            Servers
          </h1>
          <p style={{ color: '#64748b', fontSize: 15 }}>
            Private VPS monitoring — metrics fetched by ABGA backend, never exposed in the browser
          </p>
        </div>

        {error && (
          <div style={{ padding: '0.85rem 1rem', borderRadius: 12, marginBottom: '1.25rem', background: '#fef2f2', color: '#b91c1c', fontSize: 14 }}>
            {error}
          </div>
        )}

        {loading && <p style={{ color: '#64748b' }}>Loading servers…</p>}

        {!loading && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: 16,
          }}>
            {servers.map((s) => (
              <ServerCard key={s.id} server={s} onOpen={(id) => navigate(`/servers/${id}`)} />
            ))}
          </div>
        )}
      </div>
    </AppLayout>
  );
}
